export default __webpack_public_path__ + "static/media/ic_menu.562ff1cd.svg";